import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgParagraphRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M11 6.8H8.6v7.4H7.1V6.8H4.5V5.5h6.6zm3 1h1.4v1H14v4.3h1.3v1H14q-1.5 0-1.4-1.3v-4h-1v-1h.5q.7 0 .6-.7V6H14z" })
});
export default SvgParagraphRegularIcon;
